import ConfirmationDetails from './ConfirmationDetails.component';
export default ConfirmationDetails;